// extracted by mini-css-extract-plugin
export var error = "m_0";
export var fieldTitle = "m_Z";
export var fiveStar = "m_1";
export var ratingContainer = "m_W";
export var ratingSpacer = "m_Y";
export var ratingSubContainer = "m_X";